import { useEffect, useState } from "react";

/**
 * Hook to check if unauth token and baseUrlt1 are ready
 * 
 * This hook polls for token availability to prevent race conditions
 * where the token config might not be loaded yet when hooks execute
 */
export function useTokenReadiness() {
  const [isTokenReady, setIsTokenReady] = useState(false);

  const hasBaseUrlt1 = typeof window !== "undefined" && 
    !!(window as any).__authShellConfig?.apiBaseUrlt1;

  // Monitor token availability
  useEffect(() => {
    if (!hasBaseUrlt1) {
      setIsTokenReady(false);
      return;
    }

    let timeoutId: NodeJS.Timeout;
    let retryCount = 0;
    const MAX_RETRIES = 300; // 30 seconds max (300 * 100ms)

    const checkToken = () => {
      const hasToken = typeof window !== "undefined" && 
        !!(window as any).__authShellConfig?.getConfigValue?.("unAuthToken");
      
      if (hasToken) {
        setIsTokenReady(true);
      } else if (retryCount < MAX_RETRIES) {
        // Keep checking until token is available or timeout
        retryCount++;
        timeoutId = setTimeout(checkToken, 100);
      } else {
        // Timeout reached - stop polling to prevent memory leak
        console.error('[TokenReadiness] Token load timeout after 30 seconds');
        setIsTokenReady(false);
      }
    };

    checkToken();

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [hasBaseUrlt1]);

  return {
    isTokenReady,
    hasBaseUrlt1,
  };
}
